import NumberPickerTab from "@template/blocks/NumberPickerSection/component/NumberPickerTabs/NumberPickerTab";
import { useMemo, useState } from "react";
import * as S from "./styles.ts";
import NumberTransferTab from "@template/blocks/NumberPickerSection/component/NumberPickerTabs/NumberTransferTab";
import { useRouter } from "@/lib/helpers/hooks/useRouter.ts";
import RefreshCcw from "@template/icons/RefreshCcw.tsx";
import Phone from "@template/icons/Phone.tsx";
import { TTab } from "@template/components/Tabs";
import { Tabs } from "@template/components";

export interface INumberPickerTabsProps {
  countryCode?: string;
  areaCode?: string;
  defaultKey: string;
  type?: string;
  context?: "virtualLandline" | "individual" | "standard" | "transfer";
  setShowTable?: (show: boolean) => void;
  shownTable?: { standard?: boolean; memorable?: boolean; nonGeo?: boolean };
  needHeading?: boolean;
}

const NumberPickerTabs = ({
  countryCode,
  areaCode,
  defaultKey,
  type,
  context,
  setShowTable,
  shownTable,
  needHeading,
}: INumberPickerTabsProps) => {
  const router = useRouter();
  const tabs = useMemo<TTab[]>(() => {
    const isTransferContext = context === "transfer";
    const isTransferDisabled =
      context === "virtualLandline" || context === "individual";

    if (isTransferContext) {
      return [
        {
          key: "transfer",
          label: {
            startContent: <RefreshCcw />,
            value: "Transfer Phone Numbers",
          },
          content: <NumberTransferTab />,
        },
        {
          key: "",
          label: {
            startContent: <></>,
            value: "",
          },
          content: <></>,
          disabled: true,
        },
      ];
    }

    return [
      {
        key: "buy",
        label: {
          startContent: <Phone />,
          value: "Buy Phone Numbers",
        },
        content: (
          <NumberPickerTab
            defaultCountryCode={countryCode}
            defaultAreaCode={areaCode}
            defaultType={type}
            context={context}
            setShowTable={setShowTable}
            shownTable={shownTable}
          />
        ),
      },
      {
        key: "transfer",
        label: {
          startContent: <RefreshCcw />,
          value: "Transfer Phone Numbers",
        },
        content: <NumberTransferTab />,
        disabled: isTransferDisabled,
      },
    ];
  }, [context, countryCode, areaCode, type, setShowTable, shownTable]);

  const [tab, setTab] = useState(defaultKey as any);

  const handleTabChange = (t: string) => {
    // Number picker tabs do not link to different routes in virtual landline context
    const invalidContexts = new Set([
      "virtualLandline",
      "individual",
      "transfer",
    ]);

    if (!invalidContexts.has(context)) {
      setTab(t);
      router.push(
        t === "buy"
          ? "/phone-number/all-numbers"
          : "/phone-number/keep-my-number"
      );
    }
  };

  return (
    <S.NumberPickerTabsWrapper $haveHeading={needHeading}>
      <S.NumberPickerTabsContainer>
        <Tabs
          tabs={tabs}
          selected={tab}
          defaultSelected={defaultKey}
          onTabChange={handleTabChange}
        />
      </S.NumberPickerTabsContainer>
    </S.NumberPickerTabsWrapper>
  );
};

export default NumberPickerTabs;
